import {useParams, Link} from 'react-router-dom'
import {useState, useEffect, useRef } from 'react'

import hash from 'object-hash';

import fetchJsonp from "fetch-jsonp";

import 'leaflet/dist/leaflet.css';
import './map.styles.css'
import { useTranslation } from "react-i18next";
import "../../translations/i18n";

import { Map, MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'

import markerIconPng from "leaflet/dist/images/marker-icon.png"
import markerShadow from 'leaflet/dist/images/marker-shadow.png';


import { GeoJSON } from 'react-leaflet/GeoJSON'

import L from 'leaflet';



import MarkerClusterGroup from 'react-leaflet-cluster'
import MapPopup from '../MapPopup/mappopup.component';

const MapComponent = ({apiUrl, lang, fix}) => {
    
//     const {resourcesIds} = useParams();

//     var tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//         maxZoom: 18,
//         attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
//         opacity: 0.7
//     }),

// latlng = L.latLng(52.00, 19.00);

// var z2f;

// var map = L.map('map', {center: latlng, zoom: 6, layers: [tiles]});
// map.attributionControl.setPrefix('&copy; 2023 <a href="https://geo-dev.ehum.psnc.pl/">GeoHum</a>');

// var markers = L.markerClusterGroup();

// var geoJsonLayer = new L.GeoJSON();

// var geoJsonUrl ='https://geo-dev.ehum.psnc.pl/geoserver/ows';
// var defaultParameters = {
//     service: 'WFS',
//     version: '1.0.0',
//     request: 'GetFeature',
//     typeName: 'geonode:equip',
//     maxFeatures: 120,
//     outputFormat: 'text/javascript'
//     };
    
// z2f = 0;
// var params = {};
// window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
//   params[key] = value;
// });	
// if (params.id) {
//   z2f=params.id;
// }
// var parameters = L.Util.extend(defaultParameters);
// console.log(geoJsonUrl + L.Util.getParamString(parameters));
// $.ajax({
//     url: geoJsonUrl + L.Util.getParamString(parameters),
//     dataType: 'jsonp',
//     jsonpCallback: 'parseResponse',
//     success: function (data) {
//         var geoJsonLayer = L.geoJson(data, {
//             onEachFeature: function(feature, layer) {
//                 popupOptions = {maxWidth: 600, maxHeight: 500};
//                 desc = feature.properties.Id+'<br>'+feature.properties.html
//                 layer.bindPopup(desc,popupOptions);
//                 if (layer.feature.properties.Id == z2f) {
//                    console.log('zoomToFeature');
//                    fz = feature;
//                 }							
//             }
//         });
//         markers.addLayer(geoJsonLayer);
//         map.addLayer(markers);			
//         if (z2f) {
//             map.setView([fz.geometry.coordinates[1],fz.geometry.coordinates[0]], 13);
//             popupOptions = {maxWidth: 600, maxHeight: 500};
//             L.marker([fz.geometry.coordinates[1],fz.geometry.coordinates[0]]).addTo(map).bindPopup(desc,popupOptions).openPopup();	
//             desc = fz.properties.Id+'<br>'+fz.properties.html;
//             L.marker([fz.geometry.coordinates[1],fz.geometry.coordinates[0]]).addTo(map).bindPopup(desc,popupOptions).openPopup();
//         }
//     }
// });

    
   const geoJsonUrl ='https://geo-dev.ehum.psnc.pl/geoserver/ows';
    //const geoJsonUrl = 'https://geo-dev.ehum.psnc.pl/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geonode:equip&maxFeatures=120&outputFormat=text/javascript';
    var defaultParameters = {
        service: 'WFS',
        version: '1.0.0',
        request: 'GetFeature',
        typeName: 'geonode:equip',
        maxFeatures: 120,
        outputFormat: 'text/javascript'
    };

    const {resourceId} = useParams();


    var parameters = L.Util.extend(defaultParameters);
    const [data, setData] = useState(null);
    const [resources, setResources] = useState(null);
    const [zoom, setZoom] = useState(6);
    const [position, setPosition] = useState([52, 19])


    useEffect(()=>{
        window.parseResponse = (data) => {
            setData(data);
            if (fix) {
              const feature = data.features.find(x => x.properties.Id == fix);
              setPosition([feature.geometry.coordinates[1], feature.geometry.coordinates[0]]);
              setZoom(10);
            }
            
        }

        fetchJsonp(geoJsonUrl + L.Util.getParamString(parameters), {
            jsonpCallback: 'parseResponse',
            timeout: 5000,
          })
          .catch(function(ex) {
          });
          return () => {
            window.parseResponse = null;
          };
     },
     [resourceId]);

     useEffect(()=> {
        const url=apiUrl+'ShortResources/';
        fetch(url)
        .then(response=> response.json())
        .then((resources) => {
          setResources(resources);
        }).catch((error)=>{
          setResources([])
        });
     },[])

    //  useEffect(()=>{
    //     if (!data) return;
    //  },
    //  [data])
    




 /*
ar Stadia_AlidadeSmooth = L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
	maxZoom: 20,
	attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
});
 */

    return (

        <MapContainer key={hash(data)}  center={position} zoom={zoom} scrollWheelZoom={true}>
        <TileLayer attribution='&copy; 2023 <a href="https://geo-dev.ehum.psnc.pl/">GeoHum</a>'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
        <DariahMapComponent data={data} resources={resources} fix={fix}/>
         </MapContainer>
            // <MapContainer center={position} zoom={6} scrollWheelZoom={false}>
            //     <TileLayer
            //     attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            //     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            //     />
            //    <GeoJSON  key={hash(data)} data={data}/>
            // </MapContainer>

    )

}

const marker_2 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_2.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_1 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_1.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_3 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_3.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_4 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_4.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_5 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_8.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_6 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_6.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_7 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_7.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const marker_8 = L.icon({
  iconUrl: require('../../assets/img/resources/marker_6.png'), // URL do obrazu ikony
  shadowUrl: require('../../assets/img/resources/shadow.png'),
  iconSize: [50, 50],
  iconAnchor: [25, 48],
  shadowAnchor: [15, 48],
  shadowSize: [50, 50],
  popupAnchor: [0, -50]
});

const markers_type=[marker_8, marker_1, marker_2, marker_3, marker_4, marker_5, marker_6, marker_7, marker_8];


const DariahMapComponent = ({data, resources, fix}) => {
  const map = useMap();
  
  const [clusters, setClusters] = useState(null)


  useEffect(() => {
    if (resources && data && data.features.length > 0) {

      // var new_data = L.geoJSON(data, {filter: (feature) => {
      //   if (!fix) return true
      //   if (feature.properties.Id == fix)
      //     return true
      // }});

      // console.log(new_data)
      // console.log(data)

      //const bounds = new L.GeoJSON(data).getBounds();
      //map.fitBounds(bounds);
    
      const markers = data.features.map((feature, index) => {
        const resource = resources.find(x => x.Id === feature.properties.Id);
        const id_for_marker = resource.Type.sort()[0];
        
        if (fix) {
          if (feature.properties.Id == fix) {
            //map.flyTo([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], 18)
            return (
              <Marker 
          key={index} 
          position={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]}
          icon={markers_type[id_for_marker]}
          >
        </Marker>
            )
          }
          else
            return null
        }

        return (
        <Marker 
          key={index} 
          position={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]}
          icon={markers_type[id_for_marker]}
        >
          <Popup >
               {/* <p>{[feature.geometry.coordinates[1], ' ' ,feature.geometry.coordinates[0]]}</p> */}
              <MapPopup resource={resource} index={index} />
          </Popup>
        </Marker>
      )})
      setClusters(markers)
    }
  }, [data, resources, map]);


  // const pointToLayer = (feature, latlng) => {
  //   const featureId = feature.properties.Id
  //   return L.marker(latlng, {icon: myIcon});
  // }

  // const onEachFeature = (feature, layer) => {
  //   // Sprawdzanie, czy obiekt ma właściwość z pop-upem

  //   const desc = feature.properties.Id+'<br>'+feature.properties.html
  //   layer.bindPopup(desc);

  //   if (feature.properties && feature.properties.popupContent) {
  //       layer.bindPopup(feature.properties.popupContent);
  //   }
  // }

  

  return (
      //data && <GeoJSON key={hash(data)} data={data} pointToLayer={pointToLayer} onEachFeature={onEachFeature}/>
      <MarkerClusterGroup 
        chunkedLoading
        showCoverageOnHover={false}
        //spiderfyOnMaxZoom={true}
       
      >
        {clusters}
      </MarkerClusterGroup>
  )
}


export default MapComponent